<template>
    <as-category-widget disable-interactivity ref="categories"></as-category-widget>
</template>

<script>
export default {
  name: 'Category',
  props: ['categories', 'heading'],
  mounted: function () {
    this.category = this.$refs.categories
    this.category.categories = this.categories
    this.category.heading = this.heading || 'default'
    this.category.showClearButton = false
    this.category.showHeader = true
    this.category.visibleCategories = Infinity
    this.category.useTotalPercentage = true
    this.category.isLoading = false
  },
  watch: {
    categories: function (newVal) {
      this.category.categories = newVal
      this.category.valueFormatter = value => `${isNaN(value) ? '-' : value.toFixed(2)} %`
      this.category.isLoading = 'false'
    },
    heading (newVal) {
      this.category.heading = newVal
    }
  }
}
</script>
